import React from 'react';
import PropTypes from 'prop-types';

const Dash = ({
  width = 16,
  height = 3
}) => {
  const styleObj = {
    width: `${width}px`,
    height: `${height}px`
  };

  return (
    <div className="Dash bg-gray-600" style={styleObj} />
  )
}

Dash.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number
}

export default Dash;
